import { ALTERAR_REGISTROS_POR_PAGINA_ROTA_ITINERARIO, DETERMINAR_PAGINA_ATUAL_ROTA_ITINERARIO } from '../../actions/types'

export const paginaAtualRotaItinerario = (state = 1, action) => {
  switch (action.type) {
    case DETERMINAR_PAGINA_ATUAL_ROTA_ITINERARIO: {
      return action.payload
    }

    default:
      return state
  }
};


export const registrosPorPaginaRotaItinerario = (state = 10, action) => {
  switch (action.type) {
    case ALTERAR_REGISTROS_POR_PAGINA_ROTA_ITINERARIO: {
      return action.payload
    }

    default:
      return state
  }
};

